/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Mcp_1_DescInputs */

const en_vc_mcp_1_desc = /** @type {(inputs: Vc_Mcp_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask your AI agent for an icon, a poster or a diagram and watch it build real, editable paths instead of a flat image.`)
};

const zh_vc_mcp_1_desc = /** @type {(inputs: Vc_Mcp_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`让 AI 助手画一个图标、一张海报或一张示意图，它生成的是真正可编辑的路径，而不是一张死图。`)
};

/**
* | output |
* | --- |
* | "Ask your AI agent for an icon, a poster or a diagram and watch it build real, editable paths instead of a flat image." |
*
* @param {Vc_Mcp_1_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_mcp_1_desc = /** @type {((inputs?: Vc_Mcp_1_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Mcp_1_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_mcp_1_desc(inputs)
	return zh_vc_mcp_1_desc(inputs)
});
export { vc_mcp_1_desc as "vc.mcp.1.desc" }